import { request } from './client'

export async function fetchArtists() {
  return request('/artists')
}

export async function setLastUsedArtist(artistId) {
  return request('/artists/last-used', {
    method: 'POST',
    body: { artist_id: artistId },
  })
}
